import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function MatterTimelineCard({ answer }: Props) {
  const entries = answer.entries ?? [];
  return (
    <article className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-emerald-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Matter timeline
        </span>
        {entries.length > 0 && (
          <span className="text-xs text-emerald-800">
            {entries.length} entr{entries.length === 1 ? 'y' : 'ies'}
          </span>
        )}
      </div>
      {entries.length > 0 ? (
        <ul className="space-y-1">
          {entries.map((entry) => (
            <li key={`${entry.label}-${entry.value ?? ''}`} className="flex gap-2">
              <span className="font-semibold">{entry.label}:</span>
              <span>{entry.value ?? '—'}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
      )}
    </article>
  );
}
